enum ReferralStatusEnum {
	SUCCESS = 'LIBERADO',
	PENDING = 'PENDENTE',
	SCHEDULED = 'AGENDADO',
	REJECTED = 'INDEFERIDO',
	FINISHED = 'CONCLUIDO',
	UNDER_ANALYSIS = 'EM_ANALISE',
}

enum ReferralTypeEnum {
	EXAM = 'EXAME',
	SURGERY = 'CIRURGIA',
	APPOINTMENT = 'CONSULTA',
	THERAPY = 'TERAPIA',
}

type Referrals = {
	nomeProcedimento: string;
	nomePrestador?: string;
	tipoProcedimento: ReferralTypeEnum;
	status: ReferralStatusEnum;
	dtSolicitacao: string;
	dtValidade?: string | null;
	cdSenha: string;
	protocolo: string;
	protocoloSolicitacao?: string | null;
};

type ReferralsRequestContent = {
	encaminhamentos: Referrals[];
	total: number;
	page: number;
	pages: number;
};

type GetReferralsParams = {
	dtInicio?: string;
	dtFim?: string;
	tipoProcedimento?: string;
	status?: string;
	signal?: AbortSignal;
	nomeProcedimento?: string;
	page?: number;
	limit?: number;
};

type GetReferralsModel = ReferralsRequestContent;

interface GetReferrals {
	get: (params: GetReferralsParams) => Promise<GetReferralsModel>;
}

export {ReferralStatusEnum, ReferralTypeEnum};

export type {
	GetReferrals,
	GetReferralsModel,
	GetReferralsParams,
	ReferralsRequestContent,
	Referrals,
};
